import { ButtonBase, Box } from "@mui/material";
import {
  getNeuSurfaceStyles,
  getNeuVariantStyles,
} from "../../theme/themeHelpers";

function NeuButtonBase({
  children,
  sx = [],
  elevation = "control",
  activeElevation = "inset",
  ...props
}) {
  return (
    <ButtonBase
      {...props}
      sx={[
        (theme) => ({
          ...getNeuSurfaceStyles(theme, elevation),
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          transition: "transform 220ms ease",

          "&:active": {
            transform: "scale(0.98)",
            boxShadow: theme.custom.elevation[activeElevation]?.light,
            ...theme.applyStyles("dark", {
              boxShadow: theme.custom.elevation[activeElevation]?.dark,
            }),
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </ButtonBase>
  );
}

export function NeuButton({
  children,
  variant = "default",
  sx = [],
  ...props
}) {
  const isGradientBorder =
    variant === "gradientBorderLime" || variant === "gradientBorderPurple";

  return (
    <NeuButtonBase
      {...props}
      className={isGradientBorder ? "neu-gradient-button" : undefined}
      sx={[
        (theme) => ({
          minWidth: 96,
          minHeight: 42,
          px: isGradientBorder ? 0.375 : 2,
          py: isGradientBorder ? 0.375 : 0,
          fontWeight: 600,
          fontSize: "0.9rem",
          lineHeight: 1,
          whiteSpace: "nowrap",

          ...getNeuVariantStyles(theme, variant),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {isGradientBorder ? (
        <Box
          component="span"
          sx={(theme) => ({
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            px: 2,
            py: 1.25,
            borderRadius: "inherit",
            color: "inherit",
            zIndex: 0,

            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              borderRadius: "inherit",
              backgroundColor: theme.custom.surfaces.control.light,
              transition: "opacity 520ms ease-in-out",
              zIndex: -1,

              ...theme.applyStyles("dark", {
                backgroundColor: theme.custom.surfaces.control.dark,
              }),
            },

            ".neu-gradient-button:hover &::before": {
              opacity: 0,
            },

            ".neu-gradient-button:hover &": {
              color:
                variant === "gradientBorderPurple"
                  ? theme.palette.secondary.contrastText
                  : theme.palette.primary.contrastText,
            },
          })}
        >
          {children}
        </Box>
      ) : (
        children
      )}
    </NeuButtonBase>
  );
}

export function NeuIconButton({ children, sx = [], ...props }) {
  return (
    <NeuButtonBase
      {...props}
      sx={[
        (theme) => ({
          minWidth: 44,
          width: 44,
          height: 44,
          px: 1.5,
          gap: 1,
          color: theme.palette.secondary.main,
          ...theme.applyStyles("dark", { color: theme.palette.primary.main }),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </NeuButtonBase>
  );
}
